module.exports = __webpack_public_path__ + "img/student7.a71a77fe.png";